import {useTranslation} from "react-i18next";
import {useState} from "react";
import dayjs from "dayjs";

export default function AskSupport () {

    const { t } = useTranslation()

    const [sessionCode, setSessionCode] = useState<string[] | undefined>()
    const [sessionCodeDate, setSessionCodeDate] = useState<Date | undefined>()
    const [loading, setLoading] = useState<boolean>(false)

    async function generateSharingCode () {
        try {
            setLoading(true)
            const w = window as any
            w.CobrowseIO.license = 'LJfxS6ByO2oDaA'
            const client = await w.CobrowseIO.client()
            await client.start()
            const code = await client.createSessionCode()
            setSessionCode(code.split(''))
            setSessionCodeDate(new Date())
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className={'mt-8 mb-8'}>
            <button onClick={generateSharingCode}
                    className={'rounded-md font-medium px-2 py-1 bg-orange-600 text-white'}>
                {loading ? `${t('general.wait')}...` : (sessionCode === undefined) ? t('support.shareScreen') : t('support.refreshCode')}
            </button>

            {
                sessionCode &&
                <>
                    <div className={'mt-4 text-slate-600 mb-4'}>
                        {t('support.shareScreenInstruction')} {dayjs(sessionCodeDate).add(10, 'minutes').format('HH:mm')}
                    </div>
                    <div className="flex space-x-2">
                        {
                            sessionCode.map((c, i) => (
                                <div key={'accessc' + i} className={'bg-slate-200 w-14 border border-slate-300 text-center py-6 text-2xl text-slate-700 font-bold rounded-md'}>{c}</div>
                            ))
                        }
                    </div>
                </>
            }
        </div>
    )

}